module.exports = __webpack_public_path__ + "static/media/4_4.35e439a3.png";